/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import type { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import axios, { AxiosInstance, AxiosResponse } from 'axios';

import { jsonHeaders } from '../../constants/api';

export type AxiosFulfilledInterceptorType<V> = (value: V) => V | Promise<V>;
export type AxiosRejectedInterceptorType = (error: any) => any;

export type InterceptorsRequestType = Array<
  | AxiosFulfilledInterceptorType<InternalAxiosRequestConfig>
  | [AxiosFulfilledInterceptorType<InternalAxiosRequestConfig>?, AxiosRejectedInterceptorType?]
>;
export type InterceptorsResponseType<T = any> = Array<
  | AxiosFulfilledInterceptorType<AxiosResponse<T>>
  | [AxiosFulfilledInterceptorType<AxiosResponse<T>>?, AxiosRejectedInterceptorType?]
>;

export const axiosInstanceFactory = (
  config?: AxiosRequestConfig,
  reqInterceptors: InterceptorsRequestType = [],
  resInterceptors: InterceptorsResponseType = [],
): AxiosInstance => {
  if (config) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers = {
      ...jsonHeaders,
      ...config.headers,
    };
    config.withCredentials = true;
  }
  const instance = axios.create(config);
  reqInterceptors.forEach(interceptor => {
    const i = Array.isArray(interceptor) ? interceptor : [interceptor];
    instance.interceptors.request.use(i[0], i[1]);
  });
  resInterceptors.forEach(interceptor => {
    const i = Array.isArray(interceptor) ? interceptor : [interceptor];
    instance.interceptors.response.use(i[0], i[1]);
  });
  return instance;
};
